import React from 'react';
import IngredientElement from "./IngredientElement/IngredientElement";
import IngredientSearch from "./IngredientSearch/IngredientSearch";

function IngredientsList({ ingredientsArray, handleSearch, searchValue }) {
    return (
        <div className="column">
            <IngredientSearch handleSearch={handleSearch} value={searchValue} />
            <ul className="ing-list-container row three">
                {
                    ingredientsArray.map(ingredient => (
                        <IngredientElement key={ingredient.Ingredient_ID.toString()} ingredient={ingredient} />
                    ))
                }
            </ul>
        </div>
    );
}

export default IngredientsList